import { render, staticRenderFns } from "./ScoreCell.vue?vue&type=template&id=fad09a24&scoped=true&"
import script from "./ScoreCell.vue?vue&type=script&lang=js&"
export * from "./ScoreCell.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCell.vue?vue&type=style&index=0&id=fad09a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad09a24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
